






















import { UwField } from '@ultraware/vee-form-handler'
import { QField, QOptionGroup } from 'quasar'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    QField,
    QOptionGroup,
    UwField,
  },
})

export default class LicenseTypePicker extends Vue {
  @Prop({ type: Boolean, required: true }) private originalActivationCodeStatus!: boolean
  @Prop({ type: Boolean, required: true }) private activationCodeEnabled!: boolean
  @Prop({ type: Boolean, required: true }) private serviceCreditAllowed!: boolean
  @Prop({ type: Boolean, required: true }) private zeroEnabled!: boolean

  get licenseTypeArray(): string[] {
    const arr = []

    if (this.activationCodeEnabled) arr.push('activationCodeEnabled')
    if (this.serviceCreditAllowed) arr.push('serviceCreditAllowed')
    if (this.zeroEnabled) arr.push('zeroEnabled')

    return arr
  }

  set licenseTypeArray(arr: string[]) {
    // if the activation code enabled checkbox gets disabled while the article currently
    // has activation codes, ask for confirmation
    if (this.originalActivationCodeStatus && this.activationCodeEnabled &&
      !arr.includes('activationCodeEnabled')) {
      this.activationCodeDialogue()
        .onOk(() => {
          this.setPropsFromArray(arr)
        })
      return
    }

    this.setPropsFromArray(arr)
  }

  public setPropsFromArray(arr: string[]): void {
    this.$emit('update:activationCodeEnabled', arr.includes('activationCodeEnabled'))
    this.$emit('update:serviceCreditAllowed', arr.includes('serviceCreditAllowed'))
    this.$emit('update:zeroEnabled', arr.includes('zeroEnabled'))
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public activationCodeDialogue(): any {
    return this.$q.dialog({
      title: 'Weet je zeker dat je deze wijziging wilt doorvoeren?',
      message: 'Mogelijk zijn er nog activatiecodes in omloop.',
      ok: 'Bevestigen',
      cancel: 'Annuleren',
    })
  }
}
